var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEmail, IsOptional, MaxLength } from 'class-validator';
/**
 * `POST /users/:userId/update-email`. For a patient without a login the address
 * is the office's Contact address and may be cleared with `null` (#1849); for
 * anybody with an Account it is the new Login address and required.
 */
export class UpdateEmailOfUserDto {
    email;
}
__decorate([
    IsOptional(),
    IsEmail(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateEmailOfUserDto.prototype, "email", void 0);
//# sourceMappingURL=update-email-of-user.dto.js.map